let content_blocks = require('../contents');


export function init(microsite_id, content_id){

    $('#edit_row').find('.btn.btn-danger.delete_media').each(function(){
        $(this).on('click', function() {
            let modal = $(this).closest('.modal');
            let block_id = modal.find('[name="block_id"]').val();
            let block = $('#'+ block_id);
            let background = JSON.parse(block.attr('data-background'));
            let media_id = background.media_id;
            content_blocks.delete_media(media_id);
            background['media_id'] = '';
            background['url'] = '';
            background['img_name'] = '';
            block.attr('data-background', JSON.stringify(background));
        })
    });

    $('#edit_row').find('.visibility-devices span').each(function(){
        $(this).on('click', function(){
            let hidden = $(this).attr('data-hidden') == true || $(this).attr('data-hidden') == 'true' ? true : false;
            change_device_visible($(this), !hidden);
            $(this).attr('data-hidden', !hidden);
        });
    });

    function change_device_visible(button, hidden){
        if (hidden == true || hidden == 'true') {
            button.css({"background-color": "#f8f9fa"});
        } else {
            button.css({"background-color": "#d3d6d9"});
        }
    }

    $('#edit_row_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_row_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="classes"]').val(block.attr('data-class'));

        let background = JSON.parse(block.attr('data-background'));

        let color = background['color'];
        let size = background['size'];
        let position = background['position'];
        let img_name = background['img_name'];
        let url = background['url'];
        let media_id = background['media_id'];

        
        let translations = [];

        try {

            translations = JSON.parse(block.attr('data-translations'));
            if(typeof translations[window._content_selected_language] != 'undefined'){
                
                if(typeof translations[window._content_selected_language]['background']['color'] != 'undefined'){
                    color = translations[window._content_selected_language]['background']['color'];
                }

                if(typeof translations[window._content_selected_language]['background']['size'] != 'undefined'){
                    size = translations[window._content_selected_language]['background']['size'];
                }

                if(typeof translations[window._content_selected_language]['background']['position'] != 'undefined'){
                    position = translations[window._content_selected_language]['background']['position'];
                }

                if(typeof translations[window._content_selected_language]['background']['img_name'] != 'undefined'){
                    img_name = translations[window._content_selected_language]['background']['img_name'];
                }

                if(typeof translations[window._content_selected_language]['background']['url'] != 'undefined'){
                    url = translations[window._content_selected_language]['background']['url'];
                }
                
                if(typeof translations[window._content_selected_language]['background']['media_id'] != 'undefined'){
                    media_id = translations[window._content_selected_language]['background']['media_id'];
                }

            }

        } catch(err){}

        let device_mobile = modal.find('.visibility-devices [data-device="mobile"]');
        device_mobile.attr('data-hidden', block.attr('data-mobile-hidden'));
        change_device_visible(device_mobile, block.attr('data-mobile-hidden'));
        
        let device_tablet = modal.find('.visibility-devices  [data-device="tablet"]');
        device_tablet.attr('data-hidden', block.attr('data-tablet-hidden'));
        change_device_visible(device_tablet, block.attr('data-tablet-hidden'));
        
        let device_desktop = modal.find('.visibility-devices [data-device="desktop"]');
        device_desktop.attr('data-hidden', block.attr('data-desktop-hidden'));
        change_device_visible(device_desktop, block.attr('data-desktop-hidden'));

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="min-height-xs"]').val(block.attr('data-min-height-xs'));
        modal.find('[name="min-height-md"]').val(block.attr('data-min-height-md'));
        modal.find('[name="min-height-xl"]').val(block.attr('data-min-height-xl'));
        modal.find('[name="full_width"]').prop('checked', block.attr('data-full-width') == 'true' ? true : false);

        let color_select = modal.find('select[name="bg-color"]');
        let size_select = modal.find('select[name="bg-size"]');
        let position_select = modal.find('select[name="bg-position"]');
        
        if (color != null) {
            color_select.find('option[value="'+ color +'"]').prop('selected', true);
        } else {
            color_select.find('option:nth-child(1)').prop('selected', true);
        }
        color_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        if (size != null) {
            size_select.find('option[value="'+ size +'"]').prop('selected', true);
        } else {
            size_select.find('option:nth-child(1)').prop('selected', true);
        }
        size_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        if (position != null) {
            position_select.find('option[value="'+ position +'"]').prop('selected', true);
        } else {
            position_select.find('option:nth-child(1)').prop('selected', true);
        }
        
        position_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        let image = modal.find('input[name="media"]');
        let label = image.next('label');
        label.text(img_name);
    });

    $('#edit_row').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());

        let background = JSON.parse(block.attr('data-background'));
        background['color'] = $(this).find('[name="bg-color"]').val();
        background['size'] = $(this).find('[name="bg-size"]').val();
        background['position'] = $(this).find('[name="bg-position"]').val();

        let translations = [];
        if(window._content_languages.length > 1){

            try {
                translations = JSON.parse(block.attr('data-translations'));
                if (translations.length == 0) {
                    translations = {}
                }
            } catch(err){
                translations = [];
            }

            // preparo traducciones que no existan

            for(let _language of window._content_languages){
                if(typeof translations[_language] == 'undefined'){
                    translations[_language] = {'background' : { 'color': '', 'size': '', 'position': '', 'img_name': '' , 'url': '', 'media_id': '' }}
                }
            }

            // guardo tranduccion actual 
            translations[window._content_selected_language]['background']['color'] = background['color'];
            translations[window._content_selected_language]['background']['size'] = background['size'];
            translations[window._content_selected_language]['background']['position'] = background['position'];
            translations[window._content_selected_language]['background']['img_name'] = background['img_name'];
            translations[window._content_selected_language]['background']['url'] = background['url'];
            translations[window._content_selected_language]['background']['media_id'] = background['media_id'];

            // si es idioma base

            if(window._content_selected_language == window._locale){

                block.attr('data-background', JSON.stringify(background));

                // actualizamos traducciones vacias

                for(let _language of window._content_languages){
                    if(_language != window._locale){
                        if(translations[_language]['background']['color'] == ''){
                            translations[_language]['background']['color'] = background['color'];
                        }
                        if(translations[_language]['background']['size'] == ''){
                            translations[_language]['background']['size'] = background['size'];
                        }
                        if(translations[_language]['background']['position'] == ''){
                            translations[_language]['background']['position'] = background['position'];
                        }
                        if(translations[_language]['background']['url'] == ''){
                            translations[_language]['background']['url'] = background['url'];
                        }
                        if(translations[_language]['background']['img_name'] == ''){
                            translations[_language]['background']['img_name'] = background['img_name'];
                        }
                        if(translations[_language]['background']['media_id'] == ''){
                            translations[_language]['background']['media_id'] = background['media_id'];
                        }
                    }
                }

            }

        } else {
            block.attr('data-background', JSON.stringify(background));
        }

        let device_mobile = $(this).find('.visibility-devices [data-device="mobile"]');
        block.attr('data-mobile-hidden', device_mobile.attr('data-hidden'));
        
        let device_tablet = $(this).find('.visibility-devices  [data-device="tablet"]');
        block.attr('data-tablet-hidden', device_tablet.attr('data-hidden'));
        
        let device_desktop = $(this).find('.visibility-devices [data-device="desktop"]');
        block.attr('data-desktop-hidden', device_desktop.attr('data-hidden'));

        block.attr('data-full-width', $(this).find('[name="full_width"]').prop('checked'));
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        block.attr('data-min-height-xs', $(this).find('[name="min-height-xs"]').val());
        block.attr('data-min-height-md', $(this).find('[name="min-height-md"]').val());
        block.attr('data-min-height-xl', $(this).find('[name="min-height-xl"]').val());
        block.attr('data-translations', JSON.stringify(translations));
        
        let form_data = new FormData($(this)[0]);

        if (form_data.get('media').name != '') {
            update_background_image(form_data, block);
        }
        
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');

        $(this)[0].reset();
    });

    $('#add_column_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block:not([data-type="start"])');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        let prev_column = $(button).closest('.column');
        modal.find('[name="prev_column_id"]').val(prev_column.attr('id'));
    });

    $('#edit_column_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="column_id"]').val();
        let block = $('#'+block_id);
        let card_body = block.closest('.card-body');
        let preview_column = card_body.find('.preview_columns .preview_column[data-column-id="'+ block_id +'"]');
        
        block.remove();
        preview_column.remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_column').on("submit", function(e) {
        e.preventDefault();

        let column = $('#'+ $(this).find('[name="column_id"]').val());
        let preview_column = $('.preview_columns .preview_column[data-column-id="'+column.attr('id')+'"]');

        preview_column.removeClass('col-'+ $(this).find('[name="width"]').val());
        
        column.removeClass('col-xs-'+ column.attr('data-xs-width'));
        column.addClass('col-xs-'+ $(this).find('[name="xs_width"]').val());

        column.removeClass('col-md-'+ column.attr('data-md-width'));
        column.addClass('col-md-'+ $(this).find('[name="md_width"]').val());

        column.removeClass('col-xl-'+ column.attr('data-xl-width'));
        column.addClass('col-xl-'+ $(this).find('[name="xl_width"]').val());

        column.attr('data-class', $(this).find('[name="classes"]').val());
        column.attr('data-visible', $(this).find('[name="visible"]').val());
        column.attr('data-xs-width', $(this).find('[name="xs_width"]').val());
        column.attr('data-md-width', $(this).find('[name="md_width"]').val());
        column.attr('data-xl-width', $(this).find('[name="xl_width"]').val());
        column.attr('data-xs-order', $(this).find('[name="xs_order"]').val());
        column.attr('data-md-order', $(this).find('[name="md_order"]').val());
        column.attr('data-xl-order', $(this).find('[name="xl_order"]').val());

        // let background = JSON.parse(column.attr('data-background'));
        // background['color'] = $(this).find('[name="bg-color"]').val();
        // background['size'] = $(this).find('[name="bg-size"]').val();
        // background['position'] = $(this).find('[name="bg-position"]').val();
        // column.attr('data-background', JSON.stringify(background));

        preview_column.addClass('col-'+ $(this).find('[name="'+ window._blocks_device +'_width"]').val());
        preview_column.find('.info').html(`
            <span class="d-inline-block ml-2"><i class="fa-solid fa-mobile-screen"></i> ` + column.attr('data-xs-width') + `</span>
            <span class="d-inline-block ml-2"><i class="fa-solid fa-tablet-screen-button"></i> ` + column.attr('data-md-width') + `</span>
            <span class="d-inline-block ml-2"><i class="fa-solid fa-desktop"></i> ` + column.attr('data-xl-width') + `</span>
        `);

        column.find('> .card > .card-header > .info').html(`
            <span class="btn btn-xs btn-default"><i class="fa-solid fa-mobile-screen"></i> ` + column.attr('data-xs-width') + `</span>
            <span class="btn btn-xs btn-default"><i class="fa-solid fa-tablet-screen-button"></i> ` + column.attr('data-md-width') + `</span>
            <span class="btn btn-xs btn-default"><i class="fa-solid fa-desktop"></i> ` + column.attr('data-xl-width') + `</span>
        `);

        // let form_data = new FormData($(this)[0]);
        // if (form_data.get('media').name != '') {
        //     update_background_image(form_data, column);
        // }

        content_blocks.change_visible_button_blocks(column);

        let modal = $(this).closest('.modal');
        modal.modal('hide');
        
        $(this)[0].reset();
    });

    $('#add_column').on("submit", function(e) {
        e.preventDefault();

        let form_data = new FormData($(this)[0]);
        
        form_data.append('new_block_id', window.app.microsites.contents.get_random_id(10));
        form_data.append('type', 'column');
        form_data.append('device', window._blocks_device);

        let modal = $(this).closest('.modal');
        modal.modal('hide');
        $(this).trigger('reset');

        get_column_view(form_data);
        
    });

    $('#content_blocks .columns').each(function(){
        init_columns($(this).attr('id'));
    });

    $('.block[data-type="row"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}

export function get_column_view(form_data) {

    let url = window._routes['microsites.contents.block'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    window.forms.post(url, form_data, true, true)
            .then((response) => {
                
                let prev_column = $('#' + response.data.row_id + ' .columns #' + response.data.prev_column_id);
                if(prev_column.length > 0){
                    prev_column.after(response.data.column);
                } else {
                    $('#' + response.data.row_id + ' .columns').append(response.data.column);
                }

                init_columns(response.data.row_id);
                show_start_column_block(response.data.row_id);
                content_blocks.change_visible_button_blocks($('#'+response.data.row_id));

            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
}

export function show_block_order(row_id){

    let columns = $('#' + row_id +' .columns .column');

    if (columns.length > 1) {

        for(let i=0; i<columns.length; i++){

            $(columns[i]).find('.column_up').show().prop('disabled', i == 0);
            $(columns[i]).find('.column_down').show().prop('disabled', i == columns.length - 1);
            $(columns[i]).find('.move_column').show();
    
            content_blocks.show_block_order($(columns[i]).attr('id'));
        }

    } else {

        for(let i=0; i<columns.length; i++){

            $(columns[i]).find('.column_up').hide().prop('disabled', i == 0);
            $(columns[i]).find('.column_down').hide().prop('disabled', i == columns.length - 1);
            $(columns[i]).find('.move_column').hide();
    
            content_blocks.show_block_order($(columns[i]).attr('id'));
        }
    }
}

export function init_columns(row_id){

    $('#content_blocks #' + row_id + ' .preview_columns .preview_column:not(.init)').each(function(){

        $(this).click(function(){
            let column_id = $(this).attr('data-column-id');
            $('#content_blocks #' + column_id + '.column .btn.column_edit').trigger('click');
        });

        // inicializar bloque
        $(this).addClass('init');

    });

    $('#content_blocks #' + row_id + ' .columns .column:not(.init)').each(function(){
        let column_id = $(this).attr('id');

        $('#' + column_id).find('.btn.column_up:not(.init)').click(function(){
                
            let row_id = $(this).closest('.block[data-type="row"]').attr('id');
            
            let column = $(this).closest('.column');
            let prev_column = column.prev();
            column.detach();
            prev_column.before(column);
            
            let preview_column = $(this).closest('.block').find('.preview_columns .preview_column[data-column-id="'+column.attr('id')+'"]');
            let prev_preview_column = preview_column.prev();
            preview_column.detach();
            prev_preview_column.before(preview_column);

            reorder_columns(row_id);

        }).addClass('init');

        $('#' + column_id).find('.btn.column_down:not(.init)').click(function(){
            let row_id = $(this).closest('.block[data-type="row"]').attr('id');
            let column = $(this).closest('.column');
            let next_column = column.next();
            column.detach();
            next_column.after(column);
            
            let preview_column = $(this).closest('.block').find('.preview_columns .preview_column[data-column-id="'+column.attr('id')+'"]');
            let next_preview_column = preview_column.next();
            preview_column.detach();
            next_preview_column.after(preview_column);
            
            reorder_columns(row_id);

        }).addClass('init');

        $('#' + column_id).find('.btn.column_edit').click(function(){
            
            let form = $('#edit_column');
            let column = $(this).closest('.column');

            form.find('[name="column_id"]').val(column.attr('id'));
            form.find('[name="classes"]').val(column.attr('data-class'));
            form.find('[name="xs_width"]').val(column.attr('data-xs-width'));
            form.find('[name="md_width"]').val(column.attr('data-md-width'));
            form.find('[name="xl_width"]').val(column.attr('data-xl-width'));
            form.find('[name="xs_order"]').val(column.attr('data-xs-order'));
            form.find('[name="md_order"]').val(column.attr('data-md-order'));
            form.find('[name="xl_order"]').val(column.attr('data-xl-order'));
            form.find('[name="width"]').val(column.attr('data-'+window._blocks_device+'-width'));
        });

        $('#' + column_id + ' .move_column').each(function(){

            $(this)[0].addEventListener("dragstart", (event) => {
                event.stopPropagation();
    
                let container = $(event.target).closest('.drag-container');
                container.addClass('dragging');
    
                let column = $(event.target).closest('.column');
    
                event.dataTransfer.effectAllowed = 'move';
                event.dataTransfer.setData('text/plain', column.attr('id'));
    
                var dragImage = document.createElement('div');
                dragImage.id = 'drag-handler';
                dragImage.innerHTML = '<i class="fa-solid fa-plane"></i>';
                dragImage.setAttribute('style', 'position: absolute; left: 0px; top: 0px; width: 30px; height: 30px; z-index: -1');
                document.body.appendChild(dragImage);
                event.dataTransfer.setDragImage(dragImage, 20, 20);
    
            });
        
            $(this)[0].addEventListener("dragend", (event) => {
            
                $('#drag-handler').remove();
                
                let container = $(event.target).closest('.drag-container');
                container.removeClass('dragging');
        
            });
    
        });

        $('#' + column_id + ' > .column > .btn-drop').each(function(){
        
            $(this)[0].addEventListener("dragover", (event) => {
                event.preventDefault();
            });
    
            $(this)[0].addEventListener("dragenter", (event) => {
                event.preventDefault();
                if(event.dataTransfer.getData('text/plain') != $(event.target).closest('.column').attr('id')){
                    $(event.target).addClass('drop');
                }
            });
    
            $(this)[0].addEventListener("dragleave", (event) => {
                event.preventDefault();
                $(event.target).removeClass('drop');
            });
        
            $(this)[0].addEventListener("drop", (event) => {
                event.stopPropagation();
    
                let column = $('#' + event.dataTransfer.getData('text/plain'));
                let move_after = $(event.target).closest('.column');
    
                if(
                    column.length > 0 
                    && move_after.length > 0
                    && column.attr('id') != move_after.attr('id')
                ){
                    move_after.after(column.detach());
                    let row_id = move_after.closest('.block[data-type="row"]').attr('id');
                    reorder_columns(row_id);
                }

            });
    
        });

        // inicializar bloque
        $(this).addClass('init');
        
    });

    $('#content_blocks #' + row_id + ' .column').each(function(){
        show_start_block($(this).attr('id'));
    });

    reorder_columns(row_id);

}

function reorder_columns(row_id){

    $('#content_blocks #' + row_id + ' .preview_columns .preview_column').each(function(index){
        $(this).attr('data-index', index);
        $('#'+ $(this).attr('data-column-id')).attr('data-xl-order', index +1);
    });

    show_block_order(row_id);
}

export function show_start_block(column_id){
    
    let _blocks = $('#' + column_id + '.column .block');
    if(_blocks.length > 1){
        $('#' + column_id + '.column .block[data-type="start"]').hide();
    } else {
        $('#' + column_id + '.column .block[data-type="start"]')
            .removeClass('d-none')
            .show();
    }

}

export function show_start_column_block(row_id){
    
    let _columns = $('#' + row_id + ' .columns .column');
    if(_columns.length > 0){
        $('#' + row_id + ' .block[data-type="start"]:first').hide();
    } else {
        $('#' + row_id + ' .block[data-type="start"]:first')
            .removeClass('d-none')
            .show();
    }
}

function update_background_image(form_data, block) {
    let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    form_data.append('type', block.attr('data-type'));
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                let background = JSON.parse(block.attr('data-background'));
                background['url'] = response.data.src;
                background['img_name'] = response.data.name;
                background['media_id'] = response.data.media_id;
                block.attr('data-background', JSON.stringify(background));

                translations = JSON.parse(block.attr('data-translations'));

                translations[window._content_selected_language]['background']['url'] = response.data.src;
                translations[window._content_selected_language]['background']['media_id'] = response.data.media_id;
                translations[window._content_selected_language]['background']['img_name'] = response.data.name;

                block.attr('data-translations', JSON.stringify(translations));
            }
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}
